import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/person.png'
import _imports_1 from '@/assets/video.png'


const _withScopeId = n => (_pushScopeId("data-v-92874020"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire" }
const _hoisted_2 = { class: "questionnaire-list" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "panel-head van-hairline--bottom" }
const _hoisted_5 = { class: "questionnaire-user" }
const _hoisted_6 = { class: "user-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客户信息", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 分享 ")
const _hoisted_10 = { class: "user-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "姓名", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "性别", -1))
const _hoisted_13 = { class: "panel-body" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "panel-body-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "体检", -1))
const _hoisted_18 = { class: "status" }
const _hoisted_19 = { class: "form-list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "任务编号", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "保单编号", -1))
const _hoisted_22 = { class: "warranty" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收起", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "开始时间", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "失效时间", -1))

import { ref } from 'vue';
    import { Toast } from 'vant';
    import tabbar from "src/components/common/tabbar";
    import JSEncryptUtils from 'utils/encrypt-utils';
    import dayjs from 'dayjs';
    import { PhysicalService } from 'src/services';
    import {useToken } from 'src/store';
    import { useRouter } from 'vue-router';
    import UpageList from 'src/components/common/page-list';
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { setAccessToken, setRefreshToken } = useToken();
    const router = useRouter();

    let $pageList = ref(null)
    let showShare = ref(false)
    let key = ref("")

    const options = [
    //   { name: '微信', icon: 'wechat' },
    //   { name: '微博', icon: 'weibo' },
      { name: '复制链接', icon: 'link' },
    //   { name: '分享海报', icon: 'poster' },
    //   { name: '二维码', icon: 'qrcode' },
    ];


    /**
     * 获取体检任务 
     */
    let getPhysicalList = async (parameter)=>
    {
        try {
            let { content: res } = await PhysicalService.instance.getPhysicalList(
                Object.assign({key: key.value}, parameter)
            );
            return res.data;
        } catch (err) {
            Toast(err);
        }
    }

    /**
     * 搜索 
     */
    let onSearch = (parameter)=>
    {
        $pageList.value.onRefresh()
    }

    /**
     * 跳转详情 
     */
    let onDetail = (id)=>
    {
        router.push({name: "detail", query:{id: id}})
    }
    
    /**
     * 选择分享 
     */
    let onSelectShare = ()=>
    {
        // $pageList.value.onRefresh()
    }
    

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_share_sheet = _resolveComponent("van-share-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      class: "questionnaire-search",
      shape: "round",
      modelValue: _unref(key),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(key) ? (key).value = $event : key = $event)),
      background: "#f7f7f7",
      placeholder: "客户姓名/保单号",
      onSearch: _unref(onSearch)
    }, null, 8, ["modelValue", "onSearch"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(UpageList), {
        data: _unref(getPhysicalList),
        ref: (_value, _refs) => {
          _refs['$pageList'] = _value
          _isRef($pageList) ? $pageList.value = _value : $pageList = _value
        },
        noDataTitle: "暂无信息"
      }, {
        default: _withCtx((scoped) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("button", {
                    class: "share",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(showShare) //@ts-ignore
 ? showShare.value = true : showShare = true))
                  }, [
                    _hoisted_9,
                    _createVNode(_component_van_icon, { name: "share-o" })
                  ])
                ])
              ]),
              _createElementVNode("ul", _hoisted_10, [
                _createElementVNode("li", null, [
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(scoped.item.memberName), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_12,
                  _createElementVNode("span", null, _toDisplayString(scoped.item.memberSexStr), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scoped.item.tasks, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "panel-body-warp",
                  key: item.taskId,
                  onClick: ($event: any) => (_unref(onDetail)(item.taskId))
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(item.statusStr), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_19, [
                    _createElementVNode("li", null, [
                      _hoisted_20,
                      _createElementVNode("div", null, _toDisplayString(item.taskNo), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["warranty-warp", {auto:item.active}])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.policyNumbers, (d) => {
                            return (_openBlock(), _createElementBlock("span", { key: d }, _toDisplayString(d), 1))
                          }), 128))
                        ], 2),
                        (item.policyNumbers.length>2)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "more",
                              onClick: _withModifiers(($event: any) => (item.active = !!!item.active), ["stop"])
                            }, [
                              (!item.active)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_24,
                                    _createVNode(_component_van_icon, { name: "arrow-down" })
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_25,
                                    _createVNode(_component_van_icon, { name: "arrow-up" })
                                  ], 64))
                            ], 8, _hoisted_23))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_26,
                      _createElementVNode("div", null, _toDisplayString(item.issuedTime || "N"), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_27,
                      _createElementVNode("div", null, _toDisplayString(item.invalidateTime || "N"), 1)
                    ])
                  ])
                ], 8, _hoisted_14))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_van_share_sheet, {
      show: _unref(showShare),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showShare) ? (showShare).value = $event : showShare = $event)),
      title: "立即分享给好友",
      options: options,
      onSelect: _unref(onSelectShare)
    }, null, 8, ["show", "onSelect"]),
    _createVNode(_unref(tabbar))
  ]))
}
}

})